import { Component, ElementRef, Input, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CURRENT_ISSUES_BAR_DEFAULT_COLOR,
  CURRENT_ISSUES_BAR_CLICKED_COLOR,
  DEFAULT_LIGHT_THEME_TEXT_COLOR,
  DEFAULT_LIGHT_THEME_BORDER_COLOR,
  DEFAULT_DARK_THEME_TEXT_COLOR,
  DEFAULT_DARK_THEME_BORDER_COLOR,
  HEALTH_EVENT_LABLES,
  CAMERA_EVENT_LABLES,
} from '@app-assets/constants/assets.constants';
import { AssetsService } from '@app-assets/services/assets.service';
import { DEFAULT_FONT_FAMILY } from '@app-core/constants/constants';
import { Chart } from 'chart.js';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import {
  CameraEventAggregateResponse,
  DiagnosticsQueryParams,
  GetMuteEventsResponse,
  HealthEventAggregateResponse,
  TableType,
} from '@app-assets/models/assets.model';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from '@app-core/services/data/data.service';
import { MixPanelService } from '@app-core/services/mixpanel/mix-panel.service';
@Component({
  selector: 'app-health-check',
  templateUrl: './health-check.component.html',
  styleUrls: ['./health-check.component.scss'],
})
export class HealthCheckComponent implements OnInit {
  private barColors: string[] = [];
  private chartLabels: string[] = [];
  private originalChartLabels: string[] = [];
  private chartValues: number[] = [];
  public showChart: boolean = false;
  private defaultBarColor: string = CURRENT_ISSUES_BAR_DEFAULT_COLOR;
  public virticalBarChart: Chart | undefined;
  public showDetails: boolean = true;
  private prevClickedBarIndex: number | null = null;
  public currentIssuesLoader: boolean = true;
  public displayBarLable: string = '';
  public selectedEventType: string | null = null;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public healthEventAggregate: { [key: string]: number };
  public healthEventLables: { [key: string]: { label: string } };
  public showCameraeventHeading: boolean = true;
  public currentLanguage: string = '';
  public currentFleedId: string = '';
  @Input() public currentFleetSelected: string = '';

  @Input()
  public currentTheme: string = 'light';

  public subTabselected: string = '';
  public emptyCameraEventsAggregate: boolean;

  constructor(
    private elementRef: ElementRef,
    private assetsService: AssetsService,
    private route: ActivatedRoute,
    public translate: TranslateService,
    public dataService: DataService,
    private router: Router,
    private mixpanelService: MixPanelService
  ) {}

  ngOnInit(): void {
    if (this.virticalBarChart) {
      this.virticalBarChart.destroy();
    }
    this.route.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params: DiagnosticsQueryParams) => {
      if (history.state.source === 'bar-click') {
        return;
      }
      this.subTabselected = params.subTab;
      this.getData(false);
    });

    //passing language change from here to glossary
    this.dataService._currentLanguage.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      if (value) {
        this.currentLanguage = value;
        this.changeLanguage(this.selectedEventType);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currentTheme) {
      this.changeTheme();
    }
    if (changes.currentFleetSelected && changes.currentFleetSelected.currentValue) {
      this.currentFleedId = changes.currentFleetSelected.currentValue;
      this.getData(true);
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  //based on tab selection call the api

  private getData(isRefresh?: boolean) {
    if (this.subTabselected === 'cameraevent') {
      this.selectedEventType = null;
      this.showCameraeventHeading = true;
      this.getFleetCameraEventsAggregate(isRefresh, true);
    } else if (this.subTabselected === 'healthevent') {
      this.showCameraeventHeading = false;
      this.getHealthEventsAggregate(isRefresh);
    }
  }

  public createChart(healthEventAggregate, healthEventLables) {
    if (this.virticalBarChart) {
      this.virticalBarChart.destroy();
    }

    let eventLables: { [key: string]: { label: string } };
    eventLables = healthEventLables;
    const someValue: { key: string; value: number }[] = Object.entries(healthEventAggregate)
      .filter(([, value]) => value !== 0)
      .map(([key, value]): { key: string; value: number } => ({ key, value: Number(value) }));

    this.originalChartLabels = someValue.map((event) => eventLables[event.key]?.label);

    this.chartLabels = someValue.map((obj) => this.translate.instant(eventLables[obj.key]?.label));
    this.chartValues = someValue.map((obj) => obj.value);
    const labels: string[] = this.chartLabels;
    const data: number[] = this.chartValues;

    if (data.length === 0) {
      this.showChart = false;
      this.showDetails = false;
      return;
    }

    let defaultIndex = -1;
    const { eventType } = this.route.snapshot.queryParams || {};
    if (eventType && eventLables[eventType]?.label) {
      const label = eventLables[eventType].label;
      const eventIndex = this.originalChartLabels.indexOf(label);

      if (eventIndex !== -1 && data[eventIndex] !== undefined) {
        defaultIndex = eventIndex;
      }
    } else {
      if (this.subTabselected === 'healthevent') {
        defaultIndex = data.indexOf(Math.max(...data));
      }
    }

    if (defaultIndex !== -1) {
      this.selectedEventType = someValue[defaultIndex]?.key;
    }

    this.showChart = true;
    const containerWidth = this.elementRef.nativeElement.querySelector('#currentIssuseCanves')?.clientWidth;
    const aspectRatio = containerWidth > 768 ? 1.0 : 1.2; // Adjust as needed

    this.barColors = Array(labels.length).fill(this.defaultBarColor); // Initialize all bars with the default color

    if (defaultIndex !== -1) {
      // Get the key associated with the default index
      this.barColors[defaultIndex] = CURRENT_ISSUES_BAR_CLICKED_COLOR;
      this.displayBarLable = labels[defaultIndex];
    }

    this.virticalBarChart = new Chart(this.elementRef.nativeElement.querySelector('#currentIssuseCanves'), {
      type: 'bar',
      data: {
        labels: labels, // Split labels into arrays of words and convert to uppercase
        datasets: [
          {
            data: data,
            backgroundColor: this.barColors,
            borderRadius: 5,
            barPercentage: 0.2,
            hoverBackgroundColor: CURRENT_ISSUES_BAR_CLICKED_COLOR,
            // categoryPercentage: 0.8,
          },
        ],
      },
      options: {
        aspectRatio: aspectRatio,
        responsive: true, // Enable responsiveness
        maintainAspectRatio: false, // Disable aspect ratio maintenance
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            boxWidth: 10,
            boxHeight: 10,
            boxPadding: 4,
            cornerRadius: 4,
            usePointStyle: true,
            bodyFont: {
              family: DEFAULT_FONT_FAMILY,
            },
          },
        },
        scales: {
          y: {
            title: {
              display: true,
              text: this.translate.instant('No. of Devices'),
              font: {
                family: DEFAULT_FONT_FAMILY,
                size: 15,
                lineHeight: 3,
              },
              color: DEFAULT_LIGHT_THEME_TEXT_COLOR,
            },

            ticks: {
              font: {
                family: DEFAULT_FONT_FAMILY,
                size: 12,
              },
              color: DEFAULT_LIGHT_THEME_TEXT_COLOR,
              precision: 0,
            },
          },
          x: {
            grid: {
              display: false, // Hide the y-axis title
            },

            ticks: {
              font: {
                // Set the font properties for the x-axis labels
                size: 12,
                family: DEFAULT_FONT_FAMILY, // Set the font family for the x-axis labels
              },
              color: DEFAULT_LIGHT_THEME_TEXT_COLOR,
              maxRotation: 90, // Set the maximum rotation to 0 degrees
              minRotation: 0, // Set the minimum rotation to 0 degrees
              callback: (index) => {
                const labelname = `${labels[index]}`;
                const splitLabels = labelname.toString();
                return splitLabels;
              },
            },
          },
        },

        onClick: (_event, chartElements) => {
          if (defaultIndex !== -1) {
            this.barColors[defaultIndex] = this.defaultBarColor;
          }
          if (chartElements.length > 0) {
            const clickedBarIndex = chartElements[0].index;
            // Reset the color of the previously clicked bar to the default color
            if (this.prevClickedBarIndex !== null) {
              this.barColors[this.prevClickedBarIndex] = this.defaultBarColor; // Set to the default color
            }
            this.barColors[clickedBarIndex] = CURRENT_ISSUES_BAR_CLICKED_COLOR; // Change the color to blue, or any color you prefer
            this.virticalBarChart?.update();
            this.prevClickedBarIndex = clickedBarIndex;
            this.displayBarLable = labels[clickedBarIndex];
            this.selectedEventType = someValue[clickedBarIndex].key;
            this.mixpanelService.track(
              `${this.selectedEventType} Clicked in ${this.subTabselected} Events Tab- Diagnostics Tab / Assets Page`,
              {
                'Selected Event Type': this.selectedEventType,
              }
            );

            //clear route params
            const { eventType } = this.route.snapshot.queryParams || {};
            if (eventType !== this.selectedEventType) {
              this.router.navigate([], {
                relativeTo: this.route,
                queryParams: { eventType: this.selectedEventType, deviceId: null },
                queryParamsHandling: 'merge',
                state: { source: 'bar-click' },
              });
            }
          }
        },
      },
    });

    this.changeTheme();
  }

  public changeTheme() {
    if (this.virticalBarChart) {
      if (this.currentTheme === 'light') {
        this.virticalBarChart.options.plugins.legend.labels.color = DEFAULT_LIGHT_THEME_TEXT_COLOR;
        this.virticalBarChart.options.scales.y.grid.color = DEFAULT_LIGHT_THEME_BORDER_COLOR;
        this.virticalBarChart.options.scales.x.ticks.color = DEFAULT_LIGHT_THEME_TEXT_COLOR;
        this.virticalBarChart.options.scales.y.ticks.color = DEFAULT_LIGHT_THEME_TEXT_COLOR;
        if ((this.virticalBarChart.options.scales.y as any).title) {
          ((this.virticalBarChart.options.scales.y as any).title as any).color = DEFAULT_LIGHT_THEME_TEXT_COLOR;
        }
      } else {
        this.virticalBarChart.options.plugins.legend.labels.color = DEFAULT_DARK_THEME_TEXT_COLOR;
        this.virticalBarChart.options.scales.y.grid.color = DEFAULT_DARK_THEME_BORDER_COLOR;
        this.virticalBarChart.options.scales.x.ticks.color = DEFAULT_DARK_THEME_TEXT_COLOR;
        this.virticalBarChart.options.scales.y.ticks.color = DEFAULT_DARK_THEME_TEXT_COLOR;
        if ((this.virticalBarChart.options.scales.y as any).title) {
          ((this.virticalBarChart.options.scales.y as any).title as any).color = DEFAULT_DARK_THEME_TEXT_COLOR;
        }
      }
      this.virticalBarChart.update();
    }
  }

  private changeLanguage(selectedEventType?: string) {
    if (this.virticalBarChart) {
      this.originalChartLabels.forEach((element, index) => {
        this.translate.get(element).subscribe((translatedTitle) => {
          this.virticalBarChart.data.labels[index] = translatedTitle;
          this.virticalBarChart.update();
        });
      });

      if (selectedEventType) {
        if (HEALTH_EVENT_LABLES[selectedEventType]) {
          this.displayBarLable = HEALTH_EVENT_LABLES[selectedEventType].label;
        }

        if (CAMERA_EVENT_LABLES[selectedEventType]) {
          this.displayBarLable = CAMERA_EVENT_LABLES[selectedEventType].label;
        }
      }

      this.translate.get('No. of Devices').subscribe((translatedTitle) => {
        this.virticalBarChart.options.scales.y['title'].text = translatedTitle;
        this.virticalBarChart.update();
      });
    }
  }

  //HEALTH EVENTS :::
  //health event apis
  public getHealthEventsAggregate(isRefresh?: boolean, _eventType?: string) {
    this.currentIssuesLoader = true;
    const params = {
      startDate: this.assetsService.getStartDate(),
    };
    this.assetsService
      .getFleetHealthAggregate(params, isRefresh)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => {
          this.currentIssuesLoader = false;
        })
      )
      .subscribe(
        (res: HealthEventAggregateResponse) => {
          this.showChart = true;
          this.showDetails = true;
          const healtheventAgg = res.categoryAggregate;
          this.createChart(healtheventAgg, HEALTH_EVENT_LABLES);
        },
        () => {
          this.showChart = false;
          this.showDetails = false;
        }
      );
  }

  public getFleetCameraEventsAggregate(isRefresh: boolean, createChart: boolean, _eventType?: string) {
    this.currentIssuesLoader = true;
    const params = {
      startDate: this.assetsService.getStartDate(),
    };
    this.assetsService
      .getFleetCameraEventAggregate(params, isRefresh)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => {
          this.currentIssuesLoader = false;
        })
      )
      .subscribe(
        (res: CameraEventAggregateResponse) => {
          const { categoryAggregate = {} } = res || {};
          if (Object.keys(categoryAggregate)?.length === 0) {
            this.emptyCameraEventsAggregate = true;
            this.getFleetMutedEventsList();
          } else {
            this.emptyCameraEventsAggregate = false;
            this.showChart = true;
            this.showDetails = true;
            const isEventTypeExist = !!categoryAggregate[_eventType];
            if (_eventType && !isEventTypeExist) {
              this.onUnselectAll();
              _eventType = null;
            }
            if (createChart) {
              this.createChart(categoryAggregate, CAMERA_EVENT_LABLES);
            }
          }
        },
        () => {
          this.showChart = false;
          this.showDetails = false;
        }
      );
  }

  private getFleetMutedEventsList() {
    const params = {
      limit: 10,
      offset: 0,
      startDate: this.assetsService.getStartDate(),
    };

    this.assetsService
      .getMutedEventsList(params)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: GetMuteEventsResponse) => {
          const { totalCount = 0 } = res || {};
          if (totalCount > 0) {
            this.showChart = false;
            this.showDetails = true;
          } else {
            this.showChart = false;
            this.showDetails = false;
          }
        },
        () => {
          this.showChart = false;
          this.showDetails = false;
        }
      );
  }

  public selectedTableType(tableType: TableType) {
    if (tableType.refreshGraph) {
      this.showCameraeventHeading = true;
      this.getFleetCameraEventsAggregate(true, true, !tableType?.increaseCount && tableType.subEvent);
      this.updateBarGraphValue(tableType.subEvent, tableType.increaseCount, tableType.unselectAll);
    }
  }

  private updateBarGraphValue(labelToUpdate: string, increaseCount: boolean, unSelect?: boolean) {
    const chartData = this.virticalBarChart.data;
    const label = this.translate.instant(CAMERA_EVENT_LABLES[labelToUpdate].label);
    const labelIndex = chartData.labels.indexOf(label);

    if (labelIndex !== -1) {
      let currentValue = chartData.datasets[0].data[labelIndex] as number;
      currentValue = increaseCount ? currentValue + 1 : currentValue - 1;

      chartData.datasets[0].data[labelIndex] = currentValue;
      this.virticalBarChart.update();
    }

    if (unSelect) {
      this.onUnselectAll();
    }
  }

  public onUnselectAll(event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    this.clearQueryParams();

    const chartData = this.virticalBarChart.data;
    if (this.selectedEventType) {
      const label = this.translate.instant(CAMERA_EVENT_LABLES[this.selectedEventType].label);
      const labelIndex = chartData.labels.indexOf(label);
      chartData.datasets[0].backgroundColor[labelIndex] = CURRENT_ISSUES_BAR_DEFAULT_COLOR;
    }
    this.selectedEventType = '';
    this.virticalBarChart.update();
  }

  private clearQueryParams(): void {
    const queryParams = { ...this.route.snapshot.queryParams };
    if (queryParams?.deviceId || queryParams?.eventType) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { deviceId: null, eventType: null },
        queryParamsHandling: 'merge',
      });
    }
  }
}
